import type { SpectralWorkspaceSession } from '../types';
import { formatSessionCompletedAtForExport } from '../utils/resolveSessionCompletedAt';
import type { ExcelExportSheet } from './buildExcelWorkbook';
import { resolveMonitorAppVersionForDate } from './monitorAppVersionTimeline';

export const WORKSPACE_SESSION_DATES_SHEET_NAME = 'Date sessioni';

export type SessionDatesExportRow = {
  session_id: number;
  utente: string;
  data_completamento: string;
  versione_monitor: string;
};

export const buildSessionDatesExportRows = (
  sessions: SpectralWorkspaceSession[]
): SessionDatesExportRow[] =>
  [...sessions]
    .sort((left, right) => left.sessionId - right.sessionId)
    .map(session => ({
      session_id: session.sessionId,
      utente: session.patientCode ?? '',
      data_completamento: formatSessionCompletedAtForExport(session.completedAt),
      versione_monitor: resolveMonitorAppVersionForDate(session.completedAt),
    }));

export const buildSessionDatesExportSheets = (
  sessions: SpectralWorkspaceSession[]
): ExcelExportSheet[] => [
  {
    name: WORKSPACE_SESSION_DATES_SHEET_NAME,
    rows: buildSessionDatesExportRows(sessions),
  },
];

export const buildSessionDatesExportSheetNames = () => [
  WORKSPACE_SESSION_DATES_SHEET_NAME,
];
